(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  var $ = window.jQuery;

  toggleText = function() {
    var active = $("#mobile-zekerheden .item.active");
    var next   = active.next();
    if (next.length === 0) {
        next = $('#mobile-zekerheden .item:first');
    }

    active.removeClass('active');
    next.addClass('active');
  }

  setInterval(toggleText, 4000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-info"]) return;
  try {
    
  var $ = window.jQuery;

  toggleSlide = function() {
    var active = $("#slider .slide.active");
    var next   = active.next();
    if (next.length === 0) {
        next = $('#slider .slide:first');
    }

    active.removeClass('active');
    next.addClass('active');
  }

  setInterval(toggleSlide, 6000);

  } catch(e) { console.error(e); }
})();
})();
